export default "__VITE_ASSET__DwHmj0ES__"